<h2>Design nodig</h2>
<div class="upper-space">
  <div class="d-flex">
    <div>
      <div class="strong">Toegewezen aan</div>
      <mat-form-field appearance="outline">
        <mat-select
          matInput
          placeholder="Selecteer medewerker"
          [(ngModel)]="selectedDesigner"
          [compareWith]="compareEntities"
        >
          <mat-option *ngFor="let option of designerChoices" [value]="option">
            {{ option.user?.firstName | personName: option.user?.lastName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="left-space">
      <div class="strong">Deadline ontwerp</div>
      <mat-form-field appearance="outline">
        <input
          matInput
          [matDatepicker]="picker"
          placeholder="Selecteer een datum"
          [(ngModel)]="selectedDeadline"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
  <div class="upper-space">
    <textarea-input
      [placeholder]="'Interne communicatie over het ontwerp'"
      [initContent]="needsDesignDescription"
      (answer)="needsDesignDescriptionChanged($event)"
    >
    </textarea-input>
  </div>
</div>
<div class="button-container">
  <ng-container *ngIf="!submitting">
    <button class="btn close-button" (click)="closeDialog()">
      Sluiten
    </button>
    <button
      mat-button
      class="summary-dialog-button confirm-button"
      (click)="confirmNeedsDesign()"
    >
      Opslaan
    </button>
  </ng-container>
  <ng-container *ngIf="submitting">
    <mat-spinner color="primary" diameter="48"></mat-spinner>
  </ng-container>
</div>
